import { useFlag } from '@unleash/proxy-client-react'
import { useDispatch, useSelector } from 'react-redux'
import { FF_CART_IN_ORDERS } from 'src/constants/feature-flags'
import { setCartOpen } from 'src/redux-api-bridge/cart/actions'
import {
  cartByDateSelector,
  isCartOpenSelector
} from 'src/redux-api-bridge/cart/selectors'
import { useHistory } from 'react-router-dom'
import { RoutePaths } from 'src/routes/routePaths'
import { getOrderWithStock } from 'src/redux-api-bridge/order/selectors'
import { getMealsCount } from 'src/redux-api-bridge/order/utils'
import { getSubscriptionPlanSelector } from 'src/modules/MyAccount/selectors'

export function useCart(deliveryDate?: string, fixed = false) {
  const dispatch = useDispatch()
  const history = useHistory()
  const isCartOpen = useSelector(isCartOpenSelector)
  const dateCart = useSelector(cartByDateSelector)
  const mealsAdded = useSelector(getOrderWithStock)
  const userPlan = useSelector(getSubscriptionPlanSelector)
  const flagEnabled = useFlag(FF_CART_IN_ORDERS)

  const cartButtonEnabled =
    flagEnabled && ((dateCart && dateCart?.length > 0) || mealsAdded.length > 0)

  function setIsCartOpen(isOpen) {
    dispatch(setCartOpen({ isOpen }))
  }

  function toggleOrderSummary() {
    setIsCartOpen(false)
    history.push(`${RoutePaths.MENU}?date=${deliveryDate}&checkout=true`)
  }

  return {
    isCartOpen: fixed ? true : isCartOpen,
    setIsCartOpen,
    isFullCart: getMealsCount(dateCart) >= (userPlan?.mealsPerDelivery || 1),
    cartButtonEnabled,
    cartAvailable: !!dateCart,
    cartFlagEnabled: flagEnabled,
    cartStatusLoaded: dateCart !== null,
    toggleOrderSummary
  }
}
